import { MutateFormFields } from '../ui/modal-mutate-catalog/types';
import { CreateCatalogDataRequest } from '@entities/catalog/api/catalog-types';

export const normalizeSubmitValues = (values: MutateFormFields): CreateCatalogDataRequest => {
    return {
        ...values,
        products: values.products?.map((catalog) => catalog.value) || [],
        companies: values.companies?.map((catalog) => catalog.value) || [],
    };
};
